import log2 from "../../utils/log2";

let recorder = null;

export const getRecorder = () => {
    if (!recorder) recorder = VoiceRecorder();
    return recorder;
};

const log = log2("VoiceRecordersdk");

const VoiceRecorder = () => {
    let stream = null;
    let mediaRecorder = null;
    let chunks = [];
    let blob = null;

    const getStream = async () => {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorder = new MediaRecorder(stream);
    };

    const start = async (cb) => {
        log("start");
        if (!mediaRecorder) await getStream();
        if (mediaRecorder.state === "recording") return;
        chunks = [];
        mediaRecorder.onstart = (e) => cb(e);
        mediaRecorder.start();
    };

    const stop = (cb) => {
        log("stop");
        if (!mediaRecorder || (mediaRecorder.state !== "recording" && mediaRecorder.state !== "paused")) return;
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.onstop = () => {
            blob = new Blob(chunks, { type: "audio/ogg; codecs=opus" });
            cb(blob);
            for (const track of stream.getTracks()) {
                track.enabled = false;
                track.stop();
            }
            recorder = null;
        };
        mediaRecorder.stop();
    };

    const pause = () => {
        log("pause");
        if (!mediaRecorder || mediaRecorder.state !== "recording") return;
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.pause();
    };

    const resume = () => {
        log("resume");
        if (!mediaRecorder || mediaRecorder.state !== "paused") return;
        mediaRecorder.resume();
    };

    VoiceRecorder.start = start;
    VoiceRecorder.stop = stop;
    VoiceRecorder.pause = pause;
    VoiceRecorder.resume = resume;
    VoiceRecorder.mediaRecorder = mediaRecorder;

    return VoiceRecorder;
};
